import { FlexBox } from '@airship-platform/jam-web/components';
import {
  CheckmarkIcon,
  ChevronRightIcon,
} from '@airship-platform/jam-web/icons';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

interface ScoreFeatureItemProps {
  label: string;
  points: number;
  isCompleted: boolean;
  onClick?: () => void;
}

const OpenCircleIcon = () => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const ScoreFeatureItem: React.FC<ScoreFeatureItemProps> = ({
  label,
  points,
  isCompleted,
  onClick,
}) => {
  const isClickable = !isCompleted && onClick;

  return (
    <FlexBox
      alignItems="center"
      justifyContent="space-between"
      py={1}
      px={1}
      mx={-1}
      sx={{
        cursor: isClickable ? 'pointer' : 'default',
        borderRadius: 1,
        '&:hover': isClickable
          ? {
              backgroundColor: 'action.hover',
            }
          : undefined,
      }}
      onClick={isClickable ? onClick : undefined}
    >
      <FlexBox alignItems="flex-start" gap={1.5} flex={1}>
        <FlexBox
          alignItems="center"
          justifyContent="center"
          flexShrink={0}
          width={20}
          height={20}
          mt={0.5}
          color={isCompleted ? 'green.500' : 'grey.500'}
        >
          {isCompleted ? (
            <CheckmarkIcon width={16} height={16} />
          ) : (
            <OpenCircleIcon />
          )}
        </FlexBox>
        <Typography
          variant="body2"
          color={isCompleted ? 'text.secondary' : 'text.primary'}
          sx={isCompleted ? { textDecoration: 'line-through' } : undefined}
        >
          {label}
        </Typography>
      </FlexBox>

      <FlexBox alignItems="center" gap={1} flexShrink={0}>
        {!isCompleted && (
          <FlexBox color="grey.400" flexShrink={0}>
            <ChevronRightIcon width={16} height={16} />
          </FlexBox>
        )}
        <FlexBox width={60} justifyContent="center" flexShrink={0}>
          {isCompleted ? (
            <Typography variant="body2" color="text.secondary">
              +{points}
            </Typography>
          ) : (
            <Chip label={`+${points}`} size="small" color="softGreen" />
          )}
        </FlexBox>
      </FlexBox>
    </FlexBox>
  );
};

export default ScoreFeatureItem;
